


















import Vue from 'vue';
import {Component} from "vue-property-decorator";
import axiosInstance from "../../../axios";
import {GameHistoryData} from "../../../../types";

@Component({
    components: {},
    props: {}
})

export default class History extends Vue {
    private gameHistory: Array<GameHistoryData> = [];

    mounted(): void
    {
        axiosInstance.get('/profile/game/history')
            .then(response => {
                if (response.data.response) {
                    this.gameHistory = response.data.response;
                }
            });
    }
}
